import {
  REMOVE_PARTNER,
  CHANGE_PARTNER,
  CHANGE_PARTNER_ADD_ACTION,
  CHANGE_PARTNER_FLAG,
  CHANGE_COMPANY,
  CHANGE_DIRECTOR,
  VERIFED_OTP,
  CREATE_BRO,
  GET_PAN,
  SET_PAN,
  SEND_OTP,
  SEND_OTP_DATA,
  AUTH_USER,
  AUTH_TOKEN,
  KNOW_YOUR_CREDIT,
  SET_OFFER,
  GET_DOCUMENT_LIST,
  SAVE_DOCUMENT_LIST,
  CREDIT_AVAIL_RESPONSE,
  UPLOAD_DOCUMENT,
  SAVE_BRO,
  SET_WINDOW,
  CLEAR_WINDOW,
  NEXT_ESIGN,
  SET_TOAST,
  STOP_LOADER,
  START_LOADER,
  SAVE_OFFER,
  UPDATE_BRO,
  SAVE_UPDATE_BRO,
  ESIGN_INIT,
  SAVE_ESIGN_INIT,
  AUTH_TOKEN_BORROWER,
  SET_REPEAT,
  SET_REPEAT_MOBILE,
  SET_STEP,
  IFSC_API,
  SAVE_IFSC_API,
  CHECK_ESIGN,
  SAVE_ESIGN_LIST,
  PENNY_DROP_CALL,
  PENNY_DROP_DATA,
  CREATE_BANK_ACC,
  SAVE_BANK_ACC,
  GET_BANK_LIST,
  SAVE_BANK_LIST,
  INIT_EMANDATE,
  SAVE_INIT_EMANDATE,
  CHANGE_PARTNER_TEMP_FLAG,
  SET_API_KEY,
  SET_CUST_CODE,
  LOGOUT_USER,
  ERROR_ESIGN_INIT,
  PHY_NACH,
  SAVE_PHY_NACH,
  SET_API_STEP,
  SAVE_EMANDATE_LIST,
  GET_ESIGN_DOCUMENT_LIST,
  GET_EMAIL_ESIGN,
  SAVE_EMAIL_ESIGN,
  GET_PIN,
  SET_PIN,
  ADD_LOAD_DOCUMENT,
  REMOVE_LOAD_DOCUMENT
} from './constants';



function setREPEAT() {
  return {
    type: SET_REPEAT,
  };
}

function setREPEATNew(mobile_number) {
  return {
    type: SET_REPEAT_MOBILE,
    payload: {
      mobile_number,
    },
  };
}

function changeCompany(company) {
  return {
    type: CHANGE_COMPANY,
    payload: {
      company,
    },
  };
}

function changePartners(partners) {
  return {
    type: CHANGE_PARTNER,
    payload: {
      partners,
    },
  };
}

function removePartners(partners) {
  return {
    type: REMOVE_PARTNER,
    payload: {
      partners,
    },
  };
}

function changePartnersFlag(index,partner) {
  return {
    type: CHANGE_PARTNER_FLAG,
    payload: {
      index,
      partner
    },
  };
}

function changePartnersTempFlag(index,partner) {
  return {
    type: CHANGE_PARTNER_TEMP_FLAG,
    payload: {
      index,
      partner
    },
  };
}

function changeDirector(directors) {
  return {
    type: CHANGE_DIRECTOR,
    payload: {
      directors,
    },
  };
}

function getPennyBankApiDetails(ifscCode,accountNumber) {
  return {
    type: PENNY_DROP_CALL,
    payload: {
      ifscCode,
      accountNumber
    },
  };
}

function getPennyBankApiData(response) {
  return {
    type: PENNY_DROP_DATA,
    payload: {
      response
    },
  };
}

function changePartnersAction(key,action) {
  return {
    type: CHANGE_PARTNER_ADD_ACTION,
    payload: {
      key,
      action,
    },
  };
}

function verfiedOTP() {
  return {
    type: VERIFED_OTP,
  };
}

function createBROW(data) {
  return {
    type: CREATE_BRO,
    payload: {
      data
    },
  };
}

function updateBROW(data,borrowerResponse) {
  return {
    type: UPDATE_BRO,
    payload: {
      data,
      borrowerResponse
    },
  };
}

function saveBROW(data) {
  return {
    type: SAVE_BRO,
    payload: {
      data
    },
  };
}

function saveUpdateBROW(data) {
  return {
    type: SAVE_UPDATE_BRO,
    payload: {
      data
    },
  };
}


function getPAN(pan,flag = false) {
  return {
    type: GET_PAN,
    payload: {
      pan,
      flag
    },
  };
}

function setPAN(pan,response) {
  return {
    type: SET_PAN,
    payload: {
      pan,
      response
    },
  };
}

function getPIN(pin) {
  return {
    type: GET_PIN,
    payload: {
      pin
    },
  };
}

function setPIN(pin,response) {
  return {
    type: SET_PIN,
    payload: {
      pin,
      response
    },
  };
}

function sendOTPAction(data) {
  return {
    type: SEND_OTP,
    payload: {
      data
    },
  };
}

function authenticateUser(otp,otpResponse,borrowerResponse) {
  return {
    type: AUTH_USER,
    payload: {
      otp,
      otpResponse,
      borrowerResponse
    },
  };
}

function saveOTPAction(response) {
  return {
    type: SEND_OTP_DATA,
    payload: {
      response
    },
  };
}

function saveAuthTokenBorrower(response,borrower,responseAct) {
  return {
    type: AUTH_TOKEN_BORROWER,
    payload: {
      response,
      borrower,
      responseAct
    },
  };
}

function saveAuthToken(response) {
  return {
    type: AUTH_TOKEN,
    payload: {
      response
    },
  };
}

function getOffers(customer_code) {
  return {
    type: KNOW_YOUR_CREDIT,
    payload: {
      customer_code
    }
  };
}

function phyEmandate(data) {
  return {
    type: PHY_NACH
  };
}


function savePhyEmandate(response) {
  return {
    type: SAVE_PHY_NACH,
    payload: {
      response
    },
  };
}

function saveCreditAvail(response) {
  return {
    type: CREDIT_AVAIL_RESPONSE,
    payload: {
      response
    },
  };
}

function setOffertoDB(data) {
  return {
    type: SET_OFFER,
    payload: {
      data
    },
  };
}

function saveSelectOffer(response) {
  return {
    type: SAVE_OFFER,
    payload: {
      response
    },
  };
}

function getDocument() {
  return {
    type: GET_DOCUMENT_LIST
  };
}

function generateEsign() {
  return {
    type: GET_ESIGN_DOCUMENT_LIST
  };
}

function saveDocument(response) {
  return {
    type: SAVE_DOCUMENT_LIST,
    payload: {
      response
    },
  };
}


function uploadDocumentAction(file,documentId) {
  return {
    type: UPLOAD_DOCUMENT,
    payload: {
      file,
      documentId
    },
  };
}

function addLoadDocument(documentId) {
  return {
    type: ADD_LOAD_DOCUMENT,
    payload: {
      documentId
    },
  };
}

function removeLoadDocument(documentId) {
  return {
    type: REMOVE_LOAD_DOCUMENT,
    payload: {
      documentId
    },
  };
}


function setWindow(window) {
  return {
    type: SET_WINDOW,
    payload: {
      window
    },
  };
}

function clearWindow() {
  return {
    type: CLEAR_WINDOW,
  };
}

function esignPage() {
  return {
    type: NEXT_ESIGN,
  };
}

function setToastM(toast) {
  return {
    type: SET_TOAST,
    payload: {
      toast
    },
  };
}

function stopLoader(loaderName) {
  return {
    type: STOP_LOADER,
    payload: {
      loaderName
    },
  };
}

function startLoader(loaderName) {
  return {
    type: START_LOADER,
    payload: {
      loaderName
    },
  };
}

function esignInit(co_borrower_id) {
  return {
    type: ESIGN_INIT,
    payload: {
      co_borrower_id
    },
  };
}

function saveEsignData(data) {
  return {
    type: SAVE_ESIGN_INIT,
    payload: {
      data
    },
  };
}

function saveErrorEsignData(data) {
  return {
    type: ERROR_ESIGN_INIT,
    payload: {
      data
    },
  };
}

function setSTEP(step) {
  return {
    type: SET_STEP,
    payload: {
      step
    },
  };
}

function getBankApiDetail(ifsc) {
  return {
    type: IFSC_API,
    payload: {
      ifsc
    },
  };
}

function saveBankApiDetail(data) {
  return {
    type: SAVE_IFSC_API,
    payload: {
      data
    },
  };
}

function getBankAcctList(data) {
  return {
    type: GET_BANK_LIST
  };
}

function saveBankAcctList(response) {
  return {
    type: SAVE_BANK_LIST,
    payload: {
      response
    },
  };
}

function checkEsign(interVal) {
  return {
    type: CHECK_ESIGN,
    payload: {
      interVal
    },
  };
}

function saveEsignList(data,interVal) {
  return {
    type: SAVE_ESIGN_LIST,
    payload: {
      data,
      interVal
    },
  };
}

function createBankAccount(data) {
  return {
    type: CREATE_BANK_ACC,
    payload: {
      data
    },
  };
}

function saveBankAccount(response) {
  return {
    type: SAVE_BANK_ACC,
    payload: {
      response
    },
  };
}

function initEmandate(data) {
  return {
    type: INIT_EMANDATE
  };
}

function saveInitEmandate(response) {
  return {
    type: SAVE_INIT_EMANDATE,
    payload: {
      response
    },
  };
}


function setApiKey(key) {
  return {
    type: SET_API_KEY,
    payload: {
      key
    },
  };
}

function setCustomerCode(key) {
  return {
    type: SET_CUST_CODE,
    payload: {
      key
    },
  };
}

function logoutUser() {
  return {
    type: LOGOUT_USER
  };
}

function addApiStep(key) {
  return {
    type: SET_API_STEP,
    payload: {
      key
    },
  };
}
function saveEmandateList() {
  return {
    type: SAVE_EMANDATE_LIST
  };
}

function getEmailEsign(esign_id) {
  return {
    type: GET_EMAIL_ESIGN,
    payload: {
      esign_id
    },
  };
}

function saveEmailEsign(response) {
  return {
    type: SAVE_EMAIL_ESIGN,
    payload: {
      response
    },
  };
}



export { 
  changePartnersTempFlag,
  removePartners,
  initEmandate,
  saveInitEmandate,
  getBankAcctList,
  saveBankAcctList,
  createBankAccount,
  saveBankAccount,
  getPennyBankApiDetails,
  getPennyBankApiData,
  saveEsignList,
  checkEsign,
  saveBankApiDetail,
  getBankApiDetail,
  setREPEAT,
  setREPEATNew,
  setSTEP,
  saveAuthTokenBorrower,
  startLoader,
  stopLoader,
  saveBROW,
  changePartners,
  changePartnersAction,
  changeDirector,
  changePartnersFlag,
  changeCompany,
  verfiedOTP,
  createBROW,
  updateBROW,
  getPAN,
  setPAN,
  sendOTPAction,
  saveOTPAction,
  authenticateUser,
  saveAuthToken,
  getOffers,
  setOffertoDB,
  saveSelectOffer,
  getDocument,
  saveDocument,
  uploadDocumentAction,
  saveCreditAvail,
  setWindow,
  clearWindow,
  esignPage,
  setToastM,
  saveUpdateBROW,
  esignInit,
  saveEsignData,
  saveErrorEsignData,
  setApiKey,
  setCustomerCode,
  logoutUser,
  phyEmandate,
  savePhyEmandate,
  addApiStep,
  saveEmandateList,
  generateEsign,
  getEmailEsign,
  saveEmailEsign,
  setPIN,
  getPIN,
  addLoadDocument,
  removeLoadDocument
};
